import React from 'react';
import DetailsForm from '../../../Components/Customer/DetailsForm';

export default function Update() {
  return <DetailsForm />;
}
